import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/site-cover.jpg'
import _imports_1 from '@/assets/bugsy.png'


const _hoisted_1 = {
  id: "home",
  class: "relative min-h-[600px] flex items-center justify-center overflow-hidden"
}
const _hoisted_2 = { class: "absolute inset-0" }
const _hoisted_3 = {
  key: 0,
  class: "absolute inset-0 stars-bg opacity-60"
}
const _hoisted_4 = { class: "absolute inset-0 overflow-hidden pointer-events-none" }
const _hoisted_5 = { class: "relative z-10 text-center px-4 max-w-4xl mx-auto" }
const _hoisted_6 = { class: "text-4xl md:text-6xl font-extrabold text-white mb-6 leading-tight drop-shadow-lg" }
const _hoisted_7 = { class: "text-xl md:text-2xl text-white/90 mb-10 max-w-2xl mx-auto leading-relaxed" }
const _hoisted_8 = {
  href: "#register",
  class: "inline-block galaxy-btn-primary text-lg"
}

import { ref } from 'vue'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'HeroSection',
  props: {
    isDark: { type: Boolean }
  },
  setup(__props: any) {



const { t } = useI18n()
const bounce = ref(false)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("img", {
        src: _imports_0,
        alt: "Cover",
        class: "w-full h-full object-cover"
      }, null, -1)),
      _createElementVNode("div", {
        class: _normalizeClass(["absolute inset-0 transition-all duration-500", __props.isDark
          ? 'bg-gradient-to-b from-space-900/90 via-galaxy-900/80 to-space-900/95'
          : 'bg-gradient-to-b from-primary-800/80 via-primary-700/70 to-primary-900/85'
        ])
      }, null, 2)
    ]),
    (__props.isDark)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: _normalizeClass(["absolute -top-1/4 -left-1/4 w-1/2 h-1/2 rounded-full blur-3xl opacity-20", __props.isDark ? 'bg-nebula-purple' : 'bg-primary-400'])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["absolute -bottom-1/4 -right-1/4 w-1/2 h-1/2 rounded-full blur-3xl opacity-15", __props.isDark ? 'bg-nebula-pink' : 'bg-accent-400'])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["absolute top-1/3 right-1/4 w-1/3 h-1/3 rounded-full blur-3xl opacity-10", __props.isDark ? 'bg-nebula-cyan' : 'bg-secondary-300'])
      }, null, 2)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: "relative w-48 h-48 mx-auto mb-6 cursor-pointer select-none group",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (bounce.value = true)),
        onAnimationend: _cache[1] || (_cache[1] = ($event: any) => (bounce.value = false))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["absolute inset-0 rounded-full blur-2xl opacity-40 transition-opacity duration-300 group-hover:opacity-70", __props.isDark ? 'bg-nebula-purple' : 'bg-primary-400'])
        }, null, 2),
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "absolute top-2 right-4 w-2.5 h-2.5 rounded-full bg-star-gold animate-ping opacity-75" }, null, -1)),
        _cache[4] || (_cache[4] = _createElementVNode("span", {
          class: "absolute bottom-6 left-3 w-2 h-2 rounded-full bg-nebula-cyan animate-ping opacity-60",
          style: {"animation-delay":"0.5s"}
        }, null, -1)),
        _cache[5] || (_cache[5] = _createElementVNode("span", {
          class: "absolute top-8 left-1 w-1.5 h-1.5 rounded-full bg-nebula-pink animate-ping opacity-50",
          style: {"animation-delay":"1s"}
        }, null, -1)),
        _createElementVNode("img", {
          src: _imports_1,
          alt: "Bugsy — Starbugs Academy mascot",
          class: _normalizeClass(["relative w-full h-full object-contain drop-shadow-2xl transition-transform duration-300 group-hover:scale-110", [
            bounce.value ? 'bugsy-bounce' : 'animate-float',
            __props.isDark ? 'drop-shadow-[0_0_24px_rgba(124,77,255,0.5)]' : 'drop-shadow-[0_0_20px_rgba(124,58,237,0.3)]'
          ]])
        }, null, 2)
      ], 32),
      _createElementVNode("h1", _hoisted_6, _toDisplayString(_unref(t)('hero.title')), 1),
      _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)('hero.subtitle')), 1),
      _createElementVNode("a", _hoisted_8, _toDisplayString(_unref(t)('hero.cta')), 1)
    ])
  ]))
}
}

})